import React from 'react';
import {addProductStart} from '../../assets/images/images'

function NoProductCard(props) {
  return (
    <div className='full-width display-flex align-items-center flex-column justify-content-center'>
      <img src={addProductStart} alt={'no product'} width='100%' height={350} style={{objectFit: 'contain'}}/>
      <h3>Looks like you havent added any <br/>product. Add now to get started.</h3>
    </div>
  );
}

export default NoProductCard;
